import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-shuffle',
  templateUrl: './icon-shuffle.component.html',
  styleUrls: ['./icon-shuffle.component.scss']
})
export class IconShuffleComponent implements OnInit {
  @Input() color = '#262628';
  @Input() size = 18;

  constructor() { }

  ngOnInit() {
  }

}
